
import { useState } from 'react';

export default function Services() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'New Home Plumbing',
      description: 'Complete plumbing installation for new residential construction. From rough-in to fixtures, we handle every detail with precision and expertise.',
      features: ['Rough-in Installation', 'Fixture Setup', 'Water Line Connection', 'Quality Inspection']
    },
    {
      icon: 'ri-road-map-line',
      title: 'Underground Piping',
      description: 'Expert underground infrastructure installation including water mains, sewer lines, and drainage systems for residential developments.',
      features: ['Water Main Installation', 'Sewer Line Systems', 'Storm Drainage', 'Excavation Services']
    },
    {
      icon: 'ri-building-line',
      title: 'Civil Engineering Support',
      description: 'Professional civil engineering services for site development, grading, and infrastructure projects in residential and commercial settings.',
      features: ['Site Development', 'Grading & Excavation', 'Infrastructure Planning', 'Project Management']
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-[1400px] mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-[#FF6B35]/10 rounded-full mb-4">
            <span className="text-[#FF6B35] font-bold text-sm tracking-wide">OUR SERVICES</span>
          </div>
          <h3 className="text-5xl lg:text-6xl font-black text-[#0F4C81] mb-6">
            Professional Plumbing & Civil Engineering
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Specialized services for new home construction and underground infrastructure projects
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer border-2 border-transparent hover:border-[#FF6B35]"
            >
              {/* Icon */}
              <div className={`w-16 h-16 flex items-center justify-center rounded-xl mb-6 transition-all duration-300 ${
                hoveredIndex === index 
                  ? 'bg-gradient-to-br from-[#FF6B35] to-[#FF8C5A] scale-110' 
                  : 'bg-gradient-to-br from-[#0F4C81] to-[#1E88E5]'
              }`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>

              {/* Title */}
              <h4 className="text-2xl font-bold text-[#0F4C81] mb-4 group-hover:text-[#FF6B35] transition-colors">
                {service.title}
              </h4>

              {/* Description */}
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>

              {/* Features */}
              <ul className="space-y-3">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center gap-3">
                    <div className="w-5 h-5 flex items-center justify-center rounded-full bg-[#FF6B35]/10">
                      <i className="ri-check-line text-sm text-[#FF6B35]"></i>
                    </div>
                    <span className="text-sm text-gray-700 font-medium">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* Hover Effect */}
              <div className={`mt-6 pt-6 border-t-2 transition-all duration-300 ${
                hoveredIndex === index ? 'border-[#FF6B35]' : 'border-gray-100'
              }`}>
                <a href="#contact" className={`inline-flex items-center gap-2 font-semibold transition-colors cursor-pointer ${
                  hoveredIndex === index ? 'text-[#FF6B35]' : 'text-[#0F4C81]'
                }`}>
                  Learn More
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
